import React, { Component } from 'react'

import QRCode from "react-qr-code";
import * as htmlToImage from 'html-to-image';

    class QrCode extends Component {
        qrRef = React.createRef();
        constructor(props) {
            super(props);
        
        }
        downloadQR = () => {
            const node = this.qrRef.current;
            htmlToImage.toPng(node)
              .then((dataUrl) => {
                const link = document.createElement('a');
                link.download = 'QRCode.png';
                link.href = dataUrl;
                link.click();
              })
              .catch((error) => {
                console.error('oops, something went wrong!', error);
              });
          };
        render() {

            return (
                <div style={styles.qrContainer} >
                    <div style={{display:"flex", flexDirection:"column"}} ref={this.qrRef}>

                    <div style={styles.clnicName}>{this.props.name}</div>
                    <QRCode
                    size={256}
                    style={styles.qr}
                    value={this.props.id}
                    viewBox={`0 0 256 256`}
                    />
                </div>
                    <button style={styles.button} onClick={this.downloadQR}>Download Image</button>
                    </div>
            )

        }
    
    
}



const styles = {
    qrContainer: {
        marginBottom:"2rem",
        background:"white",
        maxWidth: "10rem",
        width: "10rem",
        display:'flex',
        flexDirection: 'column',
        alignSelf: "flex-end",

   
    },
    clnicName: {
        width: "100%",
        textAlign:"center",
        background: "white",
    },
    qr: {
       height: "auto",
       width: "100%",
       margin:0,
    },
    container1: { 
        display : "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        
    },
    button: {
        cursor: 'pointer',
        backgroundColor: '#4CAF50',
        border: 'none',
        color: 'white',
        padding: 7,
        textAlign: 'center',
        textDecoration: 'none',
        display: 'inline-block',
        fontSize: 16,
        userSelect: 'none',
        width: '10rem'
      }, 
}

export default QrCode